import { IInspectionCategoriesHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

export const useInspectionCategories = (): IInspectionCategoriesHook => {
  const { inspectionStore } = useStore();
  const { inspectionCategories, loading, submitCategoriesLoading } = inspectionStore;

  useEffect(() => {
    inspectionStore.getAllCategories(abp.session.tenantId);

    return () => inspectionStore.clearInspectionCategories();
  }, [inspectionStore]);

  return {
    loading,
    submitLoading: submitCategoriesLoading,
    dataSource: Array.from(inspectionCategories.values()),
  };
};
